var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id) {
      







































































































































































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};






































































pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv class=\"dialog-padding\"\u003E\u003Ch1 class=\"center\"\u003EStatus Log - {{StatusLogCtrl.employee.id}} | {{ StatusLogCtrl.employee.lastname }}, {{ StatusLogCtrl.employee.firstname }}\u003C\u002Fh1\u003E\u003Cbr\u003E\u003Cdiv ng-if=\"StatusLogCtrl.iAmAdvisor\" ng-show=\"!StatusLogCtrl.loading\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cp\u003E Reserve 3: {{StatusLogCtrl.employee.access_status.neo_comment}}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv overlay=\"StatusLogCtrl.loading\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Ch5\u003EDatum\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Ch5\u003Eneuer Status\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Ch5\u003Ealter Status\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-1\"\u003E\u003Ch5\u003Egültig ab\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-1\"\u003E\u003Ch5\u003ETicket\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-1\"\u003E\u003Ch5\u003EAIID\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-1\"\u003E \u003Ch5\u003EBearbeiter\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Ch5\u003EKommentar\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Chr\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row history-table-row\" ng-repeat=\"log in StatusLogCtrl.status_logs\" ng-class=\"{'odd': $odd}\"\u003E\u003Cdiv class=\"columns medium-2 contract-data\"\u003E \u003Cstrong\u003E{{StatusLogCtrl.status_logs.length - $index}} \u003C\u002Fstrong\u003E\u003Cspan\u003E{{ log.date * 1000 | date: 'dd.MM.yyyy HH:mm' }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2 contract-data\"\u003E{{ log.status ? log.status : \"-\" }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2 contract-data\"\u003E{{ log.old_status ? log.old_status : \"-\" }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-1 contract-data\"\u003E{{ log.future_date  ? (log.future_date * 1000 | date: 'dd.MM.yyyy') : '-' }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-1 contract-data\"\u003E{{ log.ticket ? '#' + log.ticket : \"-\" }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-1 contract-data\"\u003E{{ log.aiid ? log.aiid : \"-\" }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-1 contract-data\"\u003E{{ log.changer ? log.changer.firstname + ' ' + log.changer.lastname : \"-\" }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2 contract-data\"\u003E \u003Cspan\u003E{{log.type}} &nbsp;\u003C\u002Fspan\u003E\u003Cspan ng-if=\"log.comment\"\u003E{{ log.comment }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"log.components\"\u003EBausteine: \u003Cdiv ng-repeat=\"(key, component) in log.components\"\u003E{{key}}: {{component.comment ? component.comment : 'no comment provided'}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cbutton class=\"button button-primary center\" ng-click=\"StatusLogCtrl.close()\"\u003ESchließen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined));
    ;;return pug_html;};
module.exports = template;